<template>
    <div v-if="isPause"
        :class="meauLeft ? 'exam-sailfish first-item item-list-on-left' : 'exam-sailfish first-item item-list-on-left fold-item-list'">
        <div class="header">
            <div class="name">
                <span class="session-name ng-star-inserted">2025年{{ mecoTitle }}资格考试</span>
                <span class="ng-star-inserted"> -- {{ mecoName }}</span>
            </div>
            <div class="header-rt">
                <ul class="wrap-rt">
                    <li class="ng-tns-c204-3"></li>
                    <li class="volume-adjust">
                        <i placement="bottom" class="iconfont font-weight-bold align-middle"></i>
                    </li>
                    <li class="font-zoom ng-star-inserted">
                        <i class="el-icon-circle-plus"></i>
                        <div class="wrap-font-list">大</div>
                        <i class="el-icon-circle-plus"></i>
                    </li>
                    <li class="item-progress ng-star-inserted">
                        <div class="progress-wrap">
                            <div placement="bottom"
                                class="progress-text-wrap ng-trigger ng-trigger-slide ng-star-inserted" style=""><span
                                    class="progress-text ng-star-inserted" style="">已完成{{ fininsh }}/{{ total }}题</span>
                            </div>
                        </div>
                    </li>
                    <li class="time">
                        <div class="wrap-timer-cont ng-tns-c158-4 ng-trigger ng-trigger-collapse"
                            style="padding: 2px 10px;"><span class="wrap-time-val time-left-timer ng-tns-c158-4"
                                style="">
                                <span placement="bottom" class="time-value ng-tns-c158-4">
                                    <span class="ng-tns-c158-4">剩余：</span>
                                    <span class="ng-tns-c158-4">{{ min }} <span>分钟</span>
                                    </span>
                                </span>
                            </span>
                        </div>
                    </li>
                    <li class="temporary-leave">
                        <i class="el-icon-video-pause" @click="clickPause">暂离锁屏</i>
                    </li>
                    <li class="seat-num-block">
                        <span class="seat-num mr-2">
                            <b class="ng-tns-c204-3">座位号</b>&nbsp;
                            <b class="num pl-2 pr-2 bg-white rounded text-primary">1</b>
                        </span>
                        <span class="mobi-seat-num"><i class="iconfont"></i>
                            <b class="ng-tns-c204-3">1</b>
                        </span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="item-list">
            <div class="item-list-cont">
                <button class="btn-folder" @click="showMeauLeft">
                    <i class="el-icon-arrow-left" v-if="meauLeft"></i>
                    <i class="el-icon-arrow-right" v-else></i>
                </button>
                <div class="wrap-list-top">
                    <div class="wrap-user-info">
                        <div class="user-photo text-center">
                            <div class="default ng-star-inserted"><img height="200"
                                    src="../../../../public/images/touxiang.png">
                            </div>
                            <small class="ml-1 font-min">演示</small>
                        </div>
                    </div>
                </div>
                <div class="wrap-item-num-list">
                    <div class="wrap-navigation-tip"></div>
                    <div class="wrap-section-name ng-star-inserted">
                        <i class="el-icon-document"></i>&nbsp;
                        <div class="section-name">模拟练习</div>
                    </div>
                    <div class="ng-star-inserted" v-if="jsonData.judge > 0">
                        <div class="wrap-group-name clearfix" @click="judgeChange">
                            <span>
                                <i :class="judge == 0 ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                                <span class="group-name ml-2">判断题</span>
                            </span>
                        </div>
                        <ul class="item-num-list clearfix mt-2 ng-star-inserted"
                            :style="judge == 1 ? 'display:none;width:190px;' : 'width:190px;'">
                            <li @click="nextQuestion(item)"
                                :class="index == item ? 'mb-2 current' : questionData[item - 1].user_answer ? 'mb-2 done' : ' mb-2'"
                                v-for="item in jsonData.judge" :key="item">
                                <span class="num-val">{{ item }}</span>
                                <span v-if="questionData[item - 1].mark == true" class="marked"></span>
                            </li>
                        </ul>
                    </div>
                    <div class="ng-star-inserted" v-if="jsonData.radio > 0">
                        <div class="wrap-group-name clearfix" @click="radioChange">
                            <span>
                                <i :class="radio == 0 ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                                <span class="group-name ml-2">单选题</span>
                            </span>
                        </div>
                        <ul class="item-num-list clearfix mt-2 ng-star-inserted"
                            :style="radio == 1 ? 'display:none;width:190px;' : 'width:190px;'">
                            <li @click="nextQuestion(jsonData.judge + item)"
                                :class="index == (jsonData.judge + item) ? 'mb-2 current' : questionData[(jsonData.judge + item) - 1].user_answer ? 'mb-2 done' : ' mb-2'"
                                v-for="item in jsonData.radio" :key="item">
                                <span class="num-val">{{ jsonData.judge + item }}</span>
                                <span v-if="questionData[jsonData.judge + item - 1].mark == true" class="marked"></span>
                            </li>
                        </ul>
                    </div>
                    <div class="ng-star-inserted" v-if="jsonData.checkbox > 0">
                        <div class="wrap-group-name clearfix" @click="checkboxChange">
                            <span>
                                <i :class="checkbox == 0 ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                                <span class="group-name ml-2">多选题</span>
                            </span>
                        </div>
                        <ul class="item-num-list clearfix mt-2 ng-star-inserted"
                            :style="checkbox == 1 ? 'display:none;width:190px;' : 'width:190px;'">
                            <li @click="nextQuestion(jsonData.judge + jsonData.radio + item)"
                                :class="index == (jsonData.judge + jsonData.radio + item) ? 'mb-2 current' : questionData[(jsonData.judge + jsonData.radio + item) - 1].user_answer ? 'mb-2 done' : ' mb-2'"
                                v-for="item in jsonData.checkbox" :key="item">
                                <span class="num-val">{{ jsonData.judge + jsonData.radio + item }}</span>
                                <span v-if="questionData[jsonData.judge + jsonData.radio + item - 1].mark == true"
                                    class="marked"></span>
                            </li>
                        </ul>
                    </div>
                    <div class="ng-star-inserted" v-if="jsonData.textarea > 0">
                        <div class="wrap-group-name clearfix" @click="textareaChange">
                            <span>
                                <i :class="textarea == 0 ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                                <span class="group-name ml-2">材料分析题</span>
                            </span>
                        </div>
                        <ul class="item-num-list clearfix mt-2 ng-star-inserted"
                            :style="textarea == 1 ? 'display:none;width:190px;' : 'width:190px;'">
                            <li @click="nextQuestion(jsonData.judge + jsonData.radio + jsonData.checkbox + item)"
                                :class="index == (jsonData.judge + jsonData.radio + jsonData.checkbox + item) ? 'mb-2 current' : questionData[(jsonData.judge + jsonData.radio + jsonData.checkbox + item) - 1].user_answer ? 'mb-2 done' : ' mb-2'"
                                v-for="item in jsonData.textarea" :key="item">
                                <span class="num-val">{{ jsonData.judge + jsonData.radio + jsonData.checkbox + item
                                    }}</span>
                                <span
                                    v-if="questionData[jsonData.judge + jsonData.radio + jsonData.checkbox + item - 1].mark == true"
                                    class="marked"></span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="item-note">
                    <ul class="item-note-list">
                        <li>
                            <div class="icon-item-note current"><span class="num-val"></span></div>
                            <div>当前</div>
                        </li>
                        <li>
                            <div class="icon-item-note undo"><span class="num-val"></span></div>
                            <div>未完成</div>
                        </li>
                        <li>
                            <div class="icon-item-note done"><span class="num-val"></span></div>
                            <div>已完成</div>
                        </li>
                        <li>
                            <div class="icon-item-note markeds"><span class="num-val"></span></div>
                            <div>标记</div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="mask-for-mobile"></div>
        </div>
        <div class="rt-content">
            <div class="wrap-group-name pl-3 pr-3 ng-star-inserted">
                <div class="group-name-cont-left" v-if="question.type == 0">
                    <div class="group-name font-weight-bold ng-star-inserted">判断题</div>
                    <div class="group-description pb-1 font-weight-bold ng-star-inserted">
                        （请对下列各题表述的正确与否作出判断，“A”表示正确，“B”表示错误。每小题0.5分。）</div>
                </div>
                <div class="group-name-cont-left" v-if="question.type == 1">
                    <div class="group-name font-weight-bold ng-star-inserted">单选题</div>
                    <div class="group-description pb-1 font-weight-bold ng-star-inserted">
                        （请从下列各题的备选答案中选择一个正确答案。每小题0.5分。）</div>
                </div>
                <div class="group-name-cont-left" v-if="question.type == 2">
                    <div class="group-name font-weight-bold ng-star-inserted">多选题</div>
                    <div class="group-description pb-1 font-weight-bold ng-star-inserted">
                        （请从下列各题的备选答案中选择二至五个正确答案，多选、少选或错选均不得分。每小题1分。）</div>
                </div>
                <div class="group-name-cont-left" v-if="question.type == 3">
                    <div class="group-name font-weight-bold ng-star-inserted">材料分析题</div>
                    <div class="group-description pb-1 font-weight-bold ng-star-inserted">
                        （材料分析题不做得分计算，具体的请参考材料答案解析自行计算得分。）</div>
                </div>
                <div class="group-name-cont-right"></div>
            </div>
            <div class="rt-cont-main">
                <div class="wrap-item">
                    <div id="item-area" class="main-cont cont">
                        <div class="item item-tf">
                            <div class="wrap-item-cont zoom-cont pl-3 pr-3 pt-2 pb-2">
                                <div class="item-head pt-2 pb-3 clearfix">
                                    <span class="item-prop"><i class="item-index">{{ index }}</i></span>
                                    <div class="item-stem">
                                        <div v-html="question.title"></div>
                                    </div>
                                </div>
                                <div class="item-cont sub-answer">

                                    <ul class="topic_li" v-if="question.type == 1 || question.type == 0">
                                        <el-radio-group v-model="radioValue" @input="selectRadio"
                                            class="vertical-radio-group">
                                            <el-radio :label="item.key" v-for="(item, idx) in question.select_list"
                                                :key="idx">{{ item.key + '.' + item.value }}</el-radio>
                                        </el-radio-group>
                                    </ul>

                                    <ul class="topic_li" v-if="question.type == 2 || question.type_id == 2">
                                        <el-checkbox-group v-model="checkList" @change="selectCheck"
                                            class="vertical-radio-group">
                                            <el-checkbox :label="item.key" v-for="(item, idx) in question.select_list"
                                                :key="idx">{{ item.key + '.' + item.value }}</el-checkbox>
                                        </el-checkbox-group>
                                    </ul>

                                    <ul class="topic_li" v-if="question.type == 3">
                                        <el-input type="textarea" :rows="6" placeholder="请输入您的参考答案"
                                            v-model="textareaText" @blur="selectTextarea">
                                        </el-input>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap-tag-bar">
            <div class="tag-bar">
                <div class="wrap-btn-submit pl-3 pr-3">
                    <button class="yk-btn-primary w-100" @click="submitPaper">
                        <span>交卷</span>
                    </button>
                </div>
                <div class="btn-mark-item text-primary">
                    <div :class="question.mark ? 'icon-mark ml-3 mark-active' : 'icon-mark ml-3'" @click="openMark">
                        <i class="el-icon-collection-tag"></i>
                        <span class="txt-pc mark-txt text-sub" v-if="question.mark == false">标记本题</span>
                        <span class="txt-pc mark-txt text-sub" v-else>取消标记</span>
                    </div>
                </div>
                <div class="wrap-next-prev-btn">
                    <a href="javascript:void (0)" class="btn btn_sm" @click="openCalculator"><i
                            class="el-icon-s-grid"></i>计算器</a>
                    <span class="btn-prev-item ng-star-inserted" v-if="index != 1">
                        <button class="yk-btn-primary btn-min-width" @click="nextQuestion(index - 1)">
                            <i class="el-icon-arrow-left"></i>
                            <span>上一题</span>
                        </button>
                    </span>
                    <span class="btn-next-item" v-if="index != total">
                        <button class="yk-btn-primary btn-min-width" @click="nextQuestion(index + 1)">
                            <span>下一题</span>
                            <i class="el-icon-arrow-right"></i>
                        </button>
                    </span>
                </div>
            </div>
        </div>
        <el-dialog title="提示" :visible.sync="dialogOutVisible" width="25%">
            <span>还有{{ nums }}道题未作答，是否确认结束考试？</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmSubmit">确定</el-button>
                <el-button type="info" @click="dialogOutVisible = false">取 消</el-button>
            </span>
        </el-dialog>


        <el-dialog title="科学计算器" :modal="false" :modal-append-to-body="false" :close-on-click-modal="false" v-dialogDrag
            :visible.sync="dialogJsqVisible" width="720px" :before-close="handleClose">
            <iframe src="https://www.yitku.com/calc" frameborder="0" width="100%" height="350"></iframe>
        </el-dialog>
    </div>

    <div v-else class="wrap-entry-block student-pause-exam">
        <div class="session-title">2025年{{ mecoTitle }}资格考试</div>
        <div class="entry-block pause-exam-login">
            <div class="leave d-flex">
                <div class="entry-sub-title text-center m-0"><i class="el-icon-lock"></i>考生暂离锁屏 </div>
                <div class="time-left text-center">剩余：{{ min - nums }}分钟</div>
            </div>
            <div class="mt-3 mb-5">
                <div class="text-danger mx50">{{ txt }}</div>
                <div class="login-input d-flex">
                    <el-input v-model="code" placeholder="请输入准考证号(默认：1234)"></el-input>
                    <button class="ml-2 btn btn-primary" @click="goExam"> 继续考试</button>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
export default {
    data() {
        return {
            dialogJsqVisible: false,
            code: "",
            txt: "",
            showCode: 0,
            isPause: true,
            showSubmitSuccess: false,
            dialogOutVisible: false,
            dialogVisible: 1,
            checked: 0,
            isAuto: false,
            mecoTitle: "",
            mecoName: "",
            meauLeft: true,
            showSeeting: false,
            // 倒计时-分
            min: "",
            // 结束日期
            endDate: new Date().getTime(),
            jsonData: [],
            questionData: [],
            question: [],
            checkList: [],
            index: 1,
            nums: 0,
            pc_id: 0,
            times: 0,
            isAuto: 1,
            total: 0,
            radioValue: 0,
            checkbox: 0,
            textarea: 0,
            judge: 0,
            radio: 0,
            fininsh: 0,
            textareaText: "",
        };
    },
    mounted: function () {
        this.mecoTitle = sessionStorage.getItem("access-mecoName");
        this.mecoName = sessionStorage.getItem("access-mecoTitle");
        this.getList();
    },
    methods: {

        handleClose() {
            this.dialogJsqVisible = false;
        },

        openCalculator() {
            this.dialogJsqVisible = true;
        },

        clickPause() {
            this.isPause = !this.isPause;
        },

        goExam() {
            if (this.code == '') {
                this.txt = "准考证号不能为空";
                return false;
            }

            if (this.code == '1234') {
                this.isPause = true;
                this.countTime();

            } else {
                this.txt = "请输入正确的准考证号";
            }
        },

        radioChange() {
            this.radio = !this.radio;
        },

        checkboxChange() {
            this.checkbox = !this.checkbox;
        },

        textareaChange() {
            this.textarea = !this.textarea;
        },

        judgeChange() {
            this.judge = !this.judge;
        },

        setSeeting() {
            this.showSeeting = !this.showSeeting;
        },

        getList() {
            let that = this;
            let paper = sessionStorage.getItem('access-mecoPapers');
            console.log(JSON.parse(paper));
            let jsonPaper = JSON.parse(paper);
            //that.nTitle = jsonPaper.column_name + jsonPaper.subject_name;
            that.total = jsonPaper.nums;
            that.fininsh = jsonPaper.pc;
            that.jsonData = jsonPaper;
            that.times = jsonPaper.pc_times;
            that.questionData = jsonPaper.lists;
            that.question = jsonPaper.lists[0];
            this.radioValue = jsonPaper.lists[0].user_answer;
            that.endDate = that.endDate + jsonPaper.stime * 60 * 1000 - jsonPaper.pc_times * 1000;
            that.setPcPaper(jsonPaper.id);
            that.countTime();
        },

        selectRadio(e) {
            console.log(e);
            console.log(this.question);
            let _this = this;
            let json = this.questionData;
            let right = 0;
            json[this.index - 1].user_answer = e;
            //console.log(this.question.answer);
            if (this.question.answer == e) {
                right = 1;
            }
            json[this.index - 1].user_answer_right = right;
            let formData = {};
            this.questionData = json;
            //console.log(this.questionData);
            formData.pc_id = this.pc_id;
            formData.paper_id = this.question.p_id;
            formData.question_id = this.question.id;
            formData.user_answer_right = right;
            formData.user_answer = e;
            formData.times = this.times;
            this.axios.post("/setPcQuestion", formData).then((res) => {
                if (_this.isAuto == 1) {
                    _this.nextQuestion(_this.index + 1);
                }
                _this.fininsh = res.data;
            });
        },

        selectCheck(e) {
            console.log(e);
            let es = e.sort();
            let string = es.join("");
            console.log(string);
            let json = this.questionData;
            json[this.index - 1].user_answer = string;
            let right = 0;
            if (this.question.answer == string) {
                right = 1;
            }
            json[this.index - 1].user_answer_right = right;
            let formData = {};
            this.questionData = json;
            console.log(this.questionData);
            formData.pc_id = this.pc_id;
            formData.paper_id = this.question.p_id;
            formData.question_id = this.question.id;
            formData.user_answer_right = right;
            formData.user_answer = string;
            formData.times = this.times;
            this.axios.post("/setPcQuestion", formData).then((res) => {
                this.fininsh = res.data;
            });
        },

        selectTextarea() {
            let formData = {};
            let json = this.questionData;
            let right = 0;
            console.log(this.textareaText);
            json[this.index - 1].user_answer = this.textareaText;
            json[this.index - 1].user_answer_right = right;
            this.questionData = json;
            formData.pc_id = this.pc_id;
            formData.paper_id = this.question.p_id;
            formData.question_id = this.question.id;
            formData.user_answer_right = 0;
            formData.user_answer = this.textareaText;
            formData.times = this.times;
            this.axios.post("/setPcQuestion", formData).then((res) => {
                this.fininsh = res.data;
                this.textareaText = "";
            });
        },

        //创建记录
        setPcPaper(ids) {
            let that = this;
            let formData = {};
            formData.paper_id = ids;
            that.axios.post("/setPcPaper", formData).then((res) => {
                that.pc_id = res.data;
            });
        },

        //提交试卷
        confirmSubmit() {
            let that = this;
            let formData = {};
            formData.pc_id = that.pc_id;
            formData.times = that.times;
            formData.question = that.questionData;
            that.axios.post("/setSubmitGuide", formData).then((res) => {
                //this.showSubmitSuccess = true;
                that.leftTime = 0;
                that.$router.push({
                    path: "/guide/ces/result",
                    query: {
                        pc_id: that.pc_id,
                        column_id: that.jsonData.column_id,
                    },
                });
            });
        },

        openMark() {
            let json = this.questionData;
            json[this.index - 1].mark = !json[this.index - 1].mark;
            this.questionData = json;
        },

        //点击题号显示对应的题
        nextQuestion(ids) {
            console.log(ids);
            this.radioValue = "";
            this.checkList = [];
            let index = ids - 1;
            this.index = ids;
            this.question = this.questionData[index];
            if (ids <= 0) {
                return false;
            }
            //console.log(ids);
            //console.log(this.questionData.length);
            if (ids > this.questionData.length) {
                console.log(this.question.user_answer);
                if (this.question.type == 1 || this.question.type_id == 1 || this.question.type == 0) {
                    this.radioValue = this.question.user_answer;
                }
                if(this.question.type == 3){
                    this.textareaText = this.question.user_answer;
                }
                alert("已经是最后一题了");
                return false;
            } else {
                if (this.question.type == 1 || this.question.type_id == 1 || this.question.type == 0) {
                    this.radioValue = this.question.user_answer;
                } else if (this.question.type == 2 || this.question.type_id == 2) {
                    this.checkList = this.question.user_answer.split("");
                }else if(this.question.type == 3){
                    this.textareaText = this.question.user_answer;
                }
            }
        },

        // 倒计时
        countTime() {
            let now = new Date().getTime(); // 获取当前时间
            let endDate = new Date(this.endDate); // 设置截止时间
            let end = Number(endDate);
            //let endDate = new Date(this.assistActivityEndTime); // this.assistActivityEndTime需要倒计时的日期
            let leftTime = end - now; // 倒计时时间差
            // 定义变量 d,h,m,s保存倒计时的时间
            if (leftTime >= 0) {
                // 天
                // this.day = Math.floor(leftTime / 1000 / 60 / 60 / 24);
                // let dayh = this.day * 24
                // 时
                let h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
                h = h;
                // 分
                let m = Math.floor((leftTime / 1000 / 60) % 60);
                this.min = (h * 60) + m;
                let s = Math.floor((leftTime / 1000) % 60);
                if (this.min < 1) {
                    this.min = s;
                }
            } else {
                this.min = 0;
                return false;
                //this.confirmSubmit();
            }
            // 等于0的时候不调用
            if (Number(this.min) === 0) {
                //this.$route.query.count = 4;
                // 执行飞行任务
                this.confirmSubmit();
                return;
            } else {
                // 递归每秒调用countTime方法，显示动态时间效果,
                this.times = this.times + 1;
                if (this.isPause == true) {
                    setTimeout(this.countTime, 1000);
                    //console.log(this.times);
                    this.jsonData.pc_times = this.times;
                    sessionStorage.setItem('access-mecoPapers', JSON.stringify(this.jsonData));
                }
            }
        },

        showMeauLeft() {
            this.meauLeft = !this.meauLeft;
            console.log(this.meauLeft);
        },


        submitPaper() {
            let num = 0;
            this.questionData.forEach((element) => {
                if (element.user_answer_right != -1) {
                    num++;
                }
            });
            this.nums = this.total - num;
            //console.log(this.nums);
            this.dialogOutVisible = true;
        },

    },
};
</script>


<style scoped>
@import "../../../../public/css/guide.css";

.btn_sm {
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #0077FF;
    margin-right: 15px;
    color: #0077FF;
}

.sub-answer dd i {
    background: url(https://www.jianjiangedu.cn/home/img/pra_icon.png) no-repeat;
}

.sub-answer {
    font-size: 18px;
    padding: 10px 10px 35px 15px;
    clear: both;
    background: url(https://www.yitku.com/home/img/logo_white.png) no-repeat center;
    position: relative;
    cursor: pointer;
}

.sub-answer dd {
    display: block;
    padding: 10px 0 10px 40px;
    margin-left: -20px;
    font-size: 18px;
    line-height: 24px;
    color: #151515;
    position: relative;
    cursor: pointer;
}

.sub-answer dd i {
    width: 21px;
    height: 25px;
    display: block;
    background-position: -19px -58px;
    position: absolute;
    top: 8px;
    left: 5px;
}

.sub-answer-double dd i {
    background-position: 0 -562px;
}

.sub-answer dd span {
    color: #333;
    margin-right: 5px;
    top: 7px;
    left: 40px;
}

.btn-min-width span {
    margin-left: 5px;
    margin-right: 5px;
}

.vertical-radio-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 36px;
}

.vertical-radio-group span {
    font-size: 16px;
}

.vertical-radio-group label {
    line-height: 36px;
    font-size: 16px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
}

.student-pause-exam {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    background: url(https://demo.joytest.org/client/bg-img.b09cff364b6ff09a.png) #f0f5ff no-repeat center bottom;
    background-size: 100% auto;
    left: 0;
    z-index: 9998;
    margin: 0;
    padding: 150px 0 30px;
}

.wrap-entry-block .session-title {
    padding: 0 50px 15px;
    font-size: 30px;
    text-align: center;
    padding: 0 6rem 15px;
    line-height: 1.5;
    font-weight: 700;
}

.student-pause-exam .pause-exam-login {
    height: auto;
    border-radius: 5px;
    padding: 50px;
}

.wrap-entry-block .sign-in,
.wrap-entry-block .pause-exam-login {
    max-width: 900px;
    width: 90%;
}

.wrap-entry-block .entry-block {
    background: var(--ac-bg, #fff);
    box-shadow: 0 0 20px #abb2db80;
    overflow: hidden;
    margin: 0 auto;
    position: relative;
    border-radius: 10px;
}

.leave {
    margin-bottom: 35px;
    justify-content: center;
}

.d-flex {
    display: flex !important;
}

.student-pause-exam .entry-sub-title {
    color: #8c92ac !important;
}

.wrap-entry-block .entry-sub-title {
    margin: 0 auto 30px;
    font-size: 18px;
    font-weight: 700;
    color: #fff;
}

.text-center {
    text-align: center !important;
}

.student-pause-exam .time-left {
    font-size: 14px;
    height: 28px;
    background-color: #8c92ac;
    margin-left: 20px;
    border-radius: 4px;
    line-height: 28px;
    padding: 0 15px;
    color: #fff;
}

.student-pause-timer .wrap-timer-cont,
.student-pause-timer .wrap-timer-cont {
    background-color: #8c92ac;
}

.text-danger {
    color: var(--ac-color, #dc3545) !important;
    line-height: 40px;
    height: 40px;
}

.temporary-leave {
    cursor: pointer;
    border: 1px solid #fff;
    border-radius: 5px;
    padding: 3px 8px;
}

.item-head {
    max-height: 500px;
    overflow-y: scroll;
}
</style>
